import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchProducts(params = {}) {
  const { data } = await api.get("/products", { params });
  return data;
}

export async function fetchProduct(id) {
  const { data } = await api.get(`/products/${id}`);
  return data;
}

export async function validatePromo(code, subtotal, email = "") {
  const { data } = await api.post("/promo/validate", { code, subtotal, email });
  return data;
}

export async function createCheckout(payload) {
  const { data } = await api.post("/checkout", payload);
  return data;
}

export async function getReferralCode(email) {
  const { data } = await api.post("/referrals/code", { email });
  return data;
}

export const money = (n) =>
  n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: n % 1 ? 2 : 0 });
